import React, { useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Input } from 'reactstrap';
import './index.scss';
import { documentFilterItems } from "./../../../../../utils/constants"
import { useSelector } from 'react-redux';
const FilterFile = ({ className = '', _filter, __filter, _myAssignedSelectedFilter, _filterSelected, _sortBySelected, _myAssignedSelected }) => {
	let role = useSelector((state) => state?.user?.user?.role)
	
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const toggle = () => setDropdownOpen(prevState => !prevState);
	const _filterSelect = (val) => {
		setDropdownOpen(false);
		_filter(val)
	}

	const __filterSelect = (sortBy, order, val) => {
		setDropdownOpen(true);
		__filter(sortBy, order, val)
	}

	const __filterMyAssigned = (val) => {
		setDropdownOpen(true);
		_myAssignedSelectedFilter(val)
	}

	return (
		<Dropdown isOpen={dropdownOpen} toggle={toggle} className={`${className} ${_filterSelected != (undefined || null) ? 'show' : ''}`}>
			<DropdownToggle data-toggle="tooltip" data-placement="top" title={'Apply filter'} color='link' className='p-0 d-inline-flex align-items-center justify-content-center'>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="17.12"
					height="14.49"
					viewBox="0 0 17.12 14.49"
				>
					<g
						data-name="Group 126"
						opacity="0.46"
						transform="translate(-1157.807 -19.663)"
					>
						<path
							d="M1161.1 22.3h-2.618a.656.656 0 110-1.313c.8-.005 1.59 0 2.385 0h.232a1.406 1.406 0 01.37-.9 1.282 1.282 0 01.932-.413c.384-.006.767 0 1.151 0a1.353 1.353 0 011.521 1.316h9.06a1.542 1.542 0 01.246.009.657.657 0 01-.061 1.3c-.075.006-.151 0-.226 0h-9.019c-.118.757-.476 1.218-1.113 1.283a8.581 8.581 0 01-1.762 0 1.279 1.279 0 01-1.098-1.282z"
							data-name="Path 24"
							transform="translate(-.013)"
						></path>
						<path
							d="M1166.356 51.973a1.339 1.339 0 011.447-1.316h1.008a1.353 1.353 0 011.521 1.316h3.9a.655.655 0 01.608.973.668.668 0 01-.633.343h-3.872c-.019.1-.033.193-.053.284a1.3 1.3 0 01-1.229 1.028q-.709.017-1.418 0a1.338 1.338 0 01-1.278-1.313h-7.825a.66.66 0 11-.015-1.315h7.841z"
							data-name="Path 25"
							transform="translate(0 -25.728)"
						></path>
						<path
							d="M1165.073 84.268a1.34 1.34 0 01-1.446 1.316c-.329 0-.66-.02-.987 0a1.377 1.377 0 01-1.543-1.32h-2.543a.662.662 0 11.007-1.316h2.488a.22.22 0 00.046-.012c.025-.122.042-.25.078-.371a1.308 1.308 0 011.226-.929c.4-.007.809 0 1.213 0a1.339 1.339 0 011.462 1.316h9.141a.659.659 0 11.036 1.315h-9.177z"
							data-name="Path 26"
							transform="translate(-.014 -51.44)"
						></path>
					</g>
				</svg>
			</DropdownToggle>
			<DropdownMenu className='overflow-auto'>
				{(role == "subadmin" || role=="superadmin") &&<div className="inner mb-3">
					<DropdownItem onClick={() => __filterMyAssigned(!_myAssignedSelected)}>
							<label className='d-flex align-items-center'>
								<span className="icon d-inline-flex align-items-center justify-content-center">
									<Input type="radio" checked={_myAssignedSelected} value='1' className='flex-shrink-0' />
								</span>
								<span className="txt">
									My Assigned
								</span>
							</label>
						</DropdownItem>
				</div>}
				{
					documentFilterItems?.map((e, i) => {
						return <DropdownItem key={i} toggle={false}>
							<label className='d-flex'>
								<Input onClick={(v) => _filterSelect(v.target.value)} type="radio"
									checked={i == _filterSelected}
									value={i} name="select" className='flex-shrink-0' />
								{e.label == "Archived" ? (
									<span className={`d-inline-flex align-items-center justify-content-center`}>Archived</span>
								) : (
									<div>
										<span className={`d-inline-flex align-items-center justify-content-center ${e.is_verified == 1 ? "rounded-circle" : ""}  status-icon ${e.verified}`}>V</span>
										{e.label == "CR OR VR" ? <span className={'d-inline-flex align-items-center justify-content-center'} style={{marginLeft: '5px'}}>OR</span> : null}
										<span className={`d-inline-flex align-items-center justify-content-center ${e.is_correct == 1 ? "rounded-circle" : ""} status-icon ${e.correct}`}>C</span>
									</div>
								)}
							</label>
						</DropdownItem>
					})
				}
				<div className="sort-by-blc">
					<h2>Sort by:</h2>
					<div className="inner">
						<DropdownItem onClick={() => __filterSelect('updatedAt', '1', '1')}>
							<label className='d-flex align-items-center'>
								<span className="icon d-inline-flex align-items-center justify-content-center">
									<Input type="radio" checked={'1' == _sortBySelected} value='1' className='flex-shrink-0' />
								</span>
								<span className="txt">
									Date
									<span>-</span>
									Asc
								</span>
							</label>
						</DropdownItem>
						<DropdownItem onClick={() => __filterSelect('updatedAt', '-1', '2')}>
							<label className='d-flex align-items-center'>
								<span className="icon d-inline-flex align-items-center justify-content-center">
									<Input type="radio" checked={'2' == _sortBySelected} value='2' className='flex-shrink-0' />
								</span>
								<span className="txt">
									Date
									<span>-</span>
									Desc
								</span>
							</label>
						</DropdownItem>
						<DropdownItem onClick={() => __filterSelect('loan_number', '1', '3')}>
							<label className='d-flex align-items-center'>
								<span className="icon d-inline-flex align-items-center justify-content-center">
									<Input type="radio" checked={'3' == _sortBySelected} value='3' className='flex-shrink-0' />
								</span>
								<span className="txt">
									Loan No
									<span>-</span>
									Asc
								</span>
							</label>
						</DropdownItem>
						<DropdownItem onClick={() => __filterSelect('loan_number', '-1', '4')}>
							<label className='d-flex align-items-center'>
								<span className="icon d-inline-flex align-items-center justify-content-center">
									<Input type="radio" checked={'4' == _sortBySelected} value='4' className='flex-shrink-0' />
								</span>
								<span className="txt">
									Loan No
									<span>-</span>
									Desc
								</span>
							</label>
						</DropdownItem>
					</div>
				</div>
			</DropdownMenu>
		</Dropdown>
	);
}

export default FilterFile;